export default "__VITE_ASSET__SwCRGplp__"